import { Link } from 'react-router-dom';
import { T } from '@/lib/tokens';
import logoOnWhite from '@/assets/logo-on-white.svg';

const NotFound = () => {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: T.bg,
        padding: 24,
        textAlign: 'center',
      }}
    >
      {/* Logo mark */}
      <img
        src={logoOnWhite}
        alt="Share Shack"
        style={{ width: 40, height: 40, display: 'block', margin: '0 auto' }}
      />
      <div style={{ fontSize: 15, fontWeight: 600, color: T.text, marginTop: 4, marginBottom: 32 }}>
        Share Shack
      </div>

      <h1 style={{ fontSize: 28, fontWeight: 600, color: T.text, margin: '0 0 12px' }}>
        Page not found
      </h1>
      <p style={{ fontSize: 14, color: T.textSec, lineHeight: 1.65, margin: '0 0 24px' }}>
        This page doesn't exist or you don't have access.
      </p>
      <Link
        to="/"
        style={{ fontSize: 14, fontWeight: 600, color: T.accent, textDecoration: 'none' }}
      >
        Return to Home
      </Link>
    </div>
  );
};

export default NotFound;
